module.exports = __webpack_public_path__ + "static/media/creative-commons.ee0ddd09.png";